// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3N_8U","head":"Table_head__3psTt","col":"Table_col__2S2mA"};